import {
  type DashRouteType,
  URL_PARTNER_SCOPED,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/route-patterns'

const URL_SHOPPING_LIST = `${URL_RETAILER_SCOPED}/shopping-list`
const URL_SHOPPING_LIST_LIST = `${URL_SHOPPING_LIST}/list`
// Partner-wide Shopper list: no /warehouses/:warehouse_id — the banner scope is chosen in-page.
const URL_SHOPPING_LIST_PARTNER_SCOPED = `${URL_PARTNER_SCOPED}/shopping-list`
const URL_SHOPPING_LIST_LIST_PARTNER_SCOPED = `${URL_SHOPPING_LIST_PARTNER_SCOPED}/list`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'shopping-list'>
  | DashRouteType<'shopping-list-list'>
  | DashRouteType<'shopping-list-partner-scoped'>
  | DashRouteType<'shopping-list-list-partner-scoped'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'shopping-list': URL_SHOPPING_LIST,
  'shopping-list-list': URL_SHOPPING_LIST_LIST,
  'shopping-list-partner-scoped': URL_SHOPPING_LIST_PARTNER_SCOPED,
  'shopping-list-list-partner-scoped': URL_SHOPPING_LIST_LIST_PARTNER_SCOPED,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
